// R8-MAN — Listino prezzi: UI CRUD sul modello VoceListino (R8-M), API /api/listino/.
// R8-MAN-MULTI — selezione multipla + eliminazione batch. R8-MAN-PAGINAZIONE — pagine + ricerca.
// R8-IMP/DEDUP — import PDF async + dedup 3-casi. R8-DEDUP-MANUALE — chiedi prima di salvare.
// R8-CAT FASE 2 — vista a CARD per categoria (entità di FASE 1): la home del listino è la
//   griglia di categorie colorate; una card apre la vista filtrata (dove vivono paginazione e
//   selezione multipla); la ricerca SCAVALCA le card (risultati diretti su tutte le categorie);
//   il colore/nome si modificano dalla card riusando il meccanismo "Colore cartella" di Documenti.
import React, { useState, useEffect, useCallback } from 'react';
import { listino } from '../utils/api';
import {
  UNITA_LISTINO as UNITA, formValido, costruisciPayload,
  testiConfermaElimina, ambitoEliminazione, rifiutoInsiemeCambiato, messaggioEliminate,
  messaggioEsitoImport, etichettaAggiornata,
  COLORE_PALETTE, coloreHex, etichettaConteggio,
} from './listinoLogic';
import ListinoDaVerificare from './ListinoDaVerificare';   // R8-IMP-DEDUP
import ListinoStorico from './ListinoStorico';
import ListinoConfermaElimina from './ListinoConfermaElimina';   // FE-085

const VUOTA = { descrizione: '', prezzo_unitario: '', unita_misura: '', categoria: '', eredita_metratura: false };
const tint = (c, pct, base = 'var(--ds-bg)') => `color-mix(in srgb, ${c} ${pct}%, ${base})`;

// ── R8-CAT — card di una categoria (o "Senza categoria"): nome + conteggio + colore, hover,
//    e, per le categorie vere, menu ⋯ con rinomina / scegli colore / elimina (pattern Documenti).
function CardCategoria({ cat, onApri, onRinomina, onColore, onElimina, selMode, selected, onToggleSel }) {
  const senza = !!cat.senza;
  const hex = senza ? 'var(--ds-muted)' : coloreHex(cat.colore);
  const [menu, setMenu] = useState(false);
  const [showColors, setShowColors] = useState(false);
  const [rinominando, setRinominando] = useState(false);
  const [nomeEdit, setNomeEdit] = useState(cat.nome || '');
  const [hover, setHover] = useState(false);

  const chiudiMenu = () => { setMenu(false); setShowColors(false); };
  const salvaNome = () => {
    const n = nomeEdit.trim();
    setRinominando(false);
    if (n && n !== cat.nome) onRinomina(cat.id, n);
    else setNomeEdit(cat.nome || '');
  };

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => { setHover(false); }}
      style={{
        position: 'relative',
        border: selected ? `1px solid ${hex}` : '1px solid var(--ds-border)', borderLeft: `3px solid ${hex}`,
        borderRadius: 'var(--radius-card)',
        background: selected ? tint(hex, 14) : (hover ? tint(hex, 8) : 'var(--ds-bg)'),
        padding: '14px 15px 12px', display: 'flex', flexDirection: 'column', gap: 6,
        cursor: (selMode && senza) ? 'default' : 'pointer', opacity: (selMode && senza) ? 0.55 : 1,
        transition: 'background .13s, border-color .13s', minHeight: 84,
      }}
      onClick={() => {
        if (selMode) { if (!senza) onToggleSel(cat.id); return; }
        if (!rinominando && !menu) onApri(cat);
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {selMode && !senza && (
          <span style={{ width: 15, height: 15, borderRadius: 4, flexShrink: 0, border: `1.5px solid ${selected ? hex : 'var(--ds-border)'}`, background: selected ? hex : 'transparent', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            {selected && <span style={{ color: '#fff', fontSize: 11, lineHeight: 1 }}>✓</span>}
          </span>
        )}
        <span style={{ width: 10, height: 10, borderRadius: '50%', background: hex, flexShrink: 0 }} />
        {rinominando ? (
          <input
            autoFocus value={nomeEdit}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => setNomeEdit(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') salvaNome(); if (e.key === 'Escape') { setRinominando(false); setNomeEdit(cat.nome || ''); } }}
            onBlur={salvaNome}
            style={{ ...inputStyle, padding: '4px 8px', fontSize: 14, flex: 1 }} />
        ) : (
          <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--ds-text)', flex: 1, wordBreak: 'break-word' }}>
            {senza ? 'Senza categoria' : cat.nome}
          </span>
        )}
        {!senza && !selMode && (
          <button
            aria-label="Opzioni categoria"
            onClick={(e) => { e.stopPropagation(); setMenu((m) => !m); setShowColors(false); }}
            style={{ flexShrink: 0, width: 26, height: 26, borderRadius: 6, border: 'none', background: menu ? 'var(--chip)' : 'transparent', color: 'var(--ds-muted)', cursor: 'pointer', fontSize: 16, lineHeight: 1 }}>⋯</button>
        )}
      </div>
      <div style={{ fontSize: 12, color: 'var(--ds-muted)' }}>{etichettaConteggio(cat.voci_count)}</div>

      {menu && !senza && (
        <div onClick={(e) => e.stopPropagation()} style={{ position: 'absolute', top: 44, right: 10, zIndex: 20, minWidth: 168, background: 'var(--ds-bg)', border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', boxShadow: '0 8px 28px rgba(35,38,47,0.16)', padding: 6 }}>
          {!showColors ? (
            <>
              <button style={menuItem} onClick={() => { setMenu(false); setRinominando(true); setNomeEdit(cat.nome || ''); }}>Rinomina</button>
              <button style={menuItem} onClick={() => setShowColors(true)}>Scegli colore</button>
              <button style={{ ...menuItem, color: 'var(--ds-danger)' }}
                onClick={() => { chiudiMenu(); onElimina(cat); }}>Elimina categoria</button>
            </>
          ) : (
            <div>
              <div style={{ padding: '4px 8px 8px', fontSize: 11, fontWeight: 500, color: 'var(--ds-muted)' }}>Scegli colore</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, padding: '0 6px 4px' }}>
                {COLORE_PALETTE.map((col) => {
                  const sel = cat.colore === col.name;
                  return (
                    <div key={col.name} title={col.name}
                      onClick={() => { chiudiMenu(); onColore(cat.id, col.name); }}
                      style={{ width: 22, height: 22, borderRadius: '50%', background: col.hex, cursor: 'pointer', border: `2px solid ${sel ? 'var(--ink)' : 'transparent'}` }}
                      onMouseEnter={(e) => { if (!sel) e.currentTarget.style.borderColor = 'var(--ds-muted)'; }}
                      onMouseLeave={(e) => { if (!sel) e.currentTarget.style.borderColor = 'transparent'; }} />
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function Listino() {
  const [voci, setVoci] = useState([]);
  const [count, setCount] = useState(0);          // totale della vista corrente (paginazione)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [form, setForm] = useState(VUOTA);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [importing, setImporting] = useState(false);
  const [importProgress, setImportProgress] = useState('');
  const [esitoMsg, setEsitoMsg] = useState('');
  const [selezionate, setSelezionate] = useState(new Set());
  const [batchBusy, setBatchBusy] = useState(false);
  // FE-085 — «Seleziona tutte le N»: null = selezione per id (le spunte a video);
  // { conteggio, impronta } = TUTTE le voci del filtro, contate dal SERVER.
  const [modoFiltro, setModoFiltro] = useState(null);
  const [conferma, setConferma] = useState(null);   // null · { n, cambiato } — finestra aperta
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [daVerificareCount, setDaVerificareCount] = useState(0);
  const [mostraDaVerificare, setMostraDaVerificare] = useState(false);
  const [mostraStorico, setMostraStorico] = useState(false);
  const [dupDialog, setDupDialog] = useState(null);
  // R8-CAT FASE 2
  const [categorie, setCategorie] = useState([]);
  const [senzaCount, setSenzaCount] = useState(0);
  const [catLoading, setCatLoading] = useState(true);
  const [categoriaAttiva, setCategoriaAttiva] = useState(null);   // null=griglia · {id,nome,colore} · {senza:true}
  // Larghezza piena come le altre pagine (Home): niente colonna stretta centrata.
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches);
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  // R8-CAT — selezione multipla delle card categoria (modalità «Seleziona» → elimina batch).
  const [selCatMode, setSelCatMode] = useState(false);
  const [catSelezionate, setCatSelezionate] = useState(new Set());
  const uscitaSelCat = () => { setSelCatMode(false); setCatSelezionate(new Set()); };
  const toggleCatSel = (id) => setCatSelezionate((prev) => {
    const n = new Set(prev); if (n.has(id)) n.delete(id); else n.add(id); return n;
  });

  // La ricerca SCAVALCA le card: quando c'è un testo, si mostrano i risultati diretti su tutte
  // le categorie. Altrimenti: griglia (nessuna categoria attiva) o vista filtrata di categoria.
  const inVistaLista = !!search || categoriaAttiva !== null;

  const filtroVoci = useCallback((extra = {}) => {
    const p = { ...extra };
    if (search) p.search = search;
    else if (categoriaAttiva && categoriaAttiva.senza) p.categoria_ref = 'none';
    else if (categoriaAttiva && categoriaAttiva.id) p.categoria_ref = categoriaAttiva.id;
    return p;
  }, [search, categoriaAttiva]);

  const fetchDaVerificare = useCallback(() => {
    listino.list({ stato_import: 'da_verificare', page_size: 1 })
      .then((r) => setDaVerificareCount(typeof r.data?.count === 'number' ? r.data.count : 0))
      .catch(() => {});
  }, []);

  const fetchCategorie = useCallback(() => {
    setCatLoading(true);
    // Segue TUTTE le pagine: l'endpoint è paginato (Regola 19) e la griglia le vuole tutte —
    // fermarsi alla prima pagina nascondeva le categorie oltre la 20ª (bug prod 10/09, es. "Impianti").
    const caricaPagina = (p, acc) =>
      listino.categorie({ page: p, page_size: 100 }).then((r) => {
        const arr = r.data?.results || r.data || [];
        const tutte = acc.concat(arr);
        return (r.data && r.data.next) ? caricaPagina(p + 1, tutte) : tutte;
      });
    Promise.all([
      caricaPagina(1, []),
      listino.list({ categoria_ref: 'none', page_size: 1 }),
    ]).then(([cats, senza]) => {
      setCategorie(cats);
      setSenzaCount(typeof senza.data?.count === 'number' ? senza.data.count : 0);
    }).catch(() => {}).finally(() => setCatLoading(false));
  }, []);

  useEffect(() => { fetchCategorie(); fetchDaVerificare(); }, [fetchCategorie, fetchDaVerificare]);

  const fetchVoci = useCallback(() => {
    setLoading(true);
    setError('');
    setSelezionate(new Set());
    setModoFiltro(null); setConferma(null);
    listino.list(filtroVoci({ page, page_size: pageSize }))
      .then(res => {
        const results = res.data?.results || res.data || [];
        setVoci(results);
        setCount(typeof res.data?.count === 'number' ? res.data.count : results.length);
        if (results.length === 0 && page > 1) setPage(p => p - 1);
      })
      .catch(() => setError('Non riesco a caricare il listino. Riprova.'))
      .finally(() => setLoading(false));
  }, [page, pageSize, filtroVoci]);

  useEffect(() => {
    if (inVistaLista) fetchVoci();
    else { setVoci([]); setCount(0); setSelezionate(new Set()); setModoFiltro(null); setConferma(null); }
  }, [inVistaLista, fetchVoci]);

  // debounce ricerca: digita -> (350ms) applica + torna a pagina 1.
  useEffect(() => {
    const t = setTimeout(() => { setSearch(searchInput.trim()); setPage(1); }, 350);
    return () => clearTimeout(t);
  }, [searchInput]);

  const totalPages = Math.max(1, Math.ceil(count / pageSize));
  const resetForm = () => { setForm(VUOTA); setEditingId(null); };

  // ── Navigazione categorie ─────────────────────────────────────────────
  const apriCategoria = (cat) => {
    uscitaSelCat();
    setCategoriaAttiva(cat);
    setPage(1);
    setSearchInput('');
    setSearch('');
    setEsitoMsg('');
    if (!editingId) setForm({ ...VUOTA, categoria: cat.senza ? '' : (cat.nome || '') });
  };
  const tornaAllaGriglia = () => {
    setCategoriaAttiva(null);
    setPage(1);
    resetForm();
    fetchCategorie();   // i conteggi possono essere cambiati (elimina/sposta)
  };

  const rinominaCategoria = async (id, nome) => {
    try {
      await listino.aggiornaCategoria(id, { nome });
      setCategorie(cs => cs.map(c => c.id === id ? { ...c, nome } : c));
      if (categoriaAttiva && categoriaAttiva.id === id) setCategoriaAttiva({ ...categoriaAttiva, nome });
    } catch (e) {
      setError(e?.response?.data?.nome || 'Rinomina non riuscita (nome già usato?).');
    }
  };
  const cambiaColore = async (id, colore) => {
    try {
      await listino.aggiornaCategoria(id, { colore });
      setCategorie(cs => cs.map(c => c.id === id ? { ...c, colore } : c));
      if (categoriaAttiva && categoriaAttiva.id === id) setCategoriaAttiva({ ...categoriaAttiva, colore });
    } catch { setError('Cambio colore non riuscito.'); }
  };
  const eliminaCategoria = async (cat) => {
    if (!window.confirm(`Eliminare la categoria «${cat.nome}»? Le sue voci NON vengono eliminate: passano a «Senza categoria».`)) return;
    try {
      await listino.eliminaCategoria(cat.id);
      fetchCategorie();
    } catch { setError('Eliminazione categoria non riuscita.'); }
  };
  const eliminaCategorieSelez = async () => {
    const n = catSelezionate.size;
    if (n < 1) return;
    if (!window.confirm(`Eliminare ${n} ${n === 1 ? 'categoria' : 'categorie'}? Le voci NON vengono eliminate: passano a «Senza categoria».`)) return;
    try {
      await listino.eliminaCategorieBatch([...catSelezionate]);
      uscitaSelCat();
      fetchCategorie();
    } catch { setError('Eliminazione categorie non riuscita. Riprova.'); }
  };

  // ── Voci: crea / modifica / elimina ───────────────────────────────────
  const handleEdit = (v) => {
    setEditingId(v.id);
    setForm({
      descrizione: v.descrizione || '',
      prezzo_unitario: v.prezzo_unitario ?? '',
      unita_misura: v.unita_misura || '',
      categoria: v.categoria || '',
      eredita_metratura: Boolean(v.eredita_metratura),
    });
  };

  const dopoScrittura = () => { fetchVoci(); fetchCategorie(); fetchDaVerificare(); };

  const salvaVoce = async () => {
    setSaving(true);
    setError('');
    const payload = costruisciPayload(form);
    try {
      if (editingId) await listino.update(editingId, payload);
      else await listino.create(payload);
      setDupDialog(null);
      resetForm();
      if (categoriaAttiva && !categoriaAttiva.senza) setForm({ ...VUOTA, categoria: categoriaAttiva.nome });
      dopoScrittura();
    } catch {
      setError('Salvataggio non riuscito. Controlla i dati e riprova.');
    } finally {
      setSaving(false);
    }
  };

  const applicaAEsistente = async (voce) => {
    setSaving(true);
    setError('');
    try {
      await listino.update(voce.id, { prezzo_unitario: costruisciPayload(form).prezzo_unitario });
      if (editingId) await listino.delete(editingId);
      setDupDialog(null);
      resetForm();
      dopoScrittura();
    } catch {
      setError('Operazione non riuscita. Riprova.');
    } finally {
      setSaving(false);
    }
  };

  const handleSave = async () => {
    if (!formValido(form)) { setError('Servono almeno descrizione e prezzo.'); return; }
    setSaving(true);
    setError('');
    try {
      const { data } = await listino.verificaDuplicato({
        descrizione: form.descrizione,
        unita_misura: form.unita_misura,
        escludi_id: editingId || undefined,
      });
      if (data && data.caso !== 'diversa' && data.voce) {
        setDupDialog({ caso: data.caso, voce: data.voce });
        setSaving(false);
        return;
      }
    } catch { /* verifica fallita → degrada al salvataggio base */ }
    salvaVoce();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminare questa voce dal listino?')) return;
    try { await listino.delete(id); if (editingId === id) resetForm(); dopoScrittura(); }
    catch { setError('Eliminazione non riuscita.'); }
  };

  // ── Import PDF (async, background) ────────────────────────────────────
  const handleImportPdf = async (file) => {
    if (!file) return;
    setImporting(true); setEsitoMsg(''); setError(''); setImportProgress('Avvio import…');
    let jobId;
    try {
      const res = await listino.importaPdf(file);
      jobId = res.data?.id;
      if (!jobId) throw new Error('no job id');
      const tot = res.data?.totale_righe || 0;
      setImportProgress(tot ? `Importazione in corso… (0 di ~${tot} righe)` : 'Importazione in corso…');
    } catch (e) {
      setError(e?.response?.data?.detail || 'Import non riuscito. Assicurati che sia un PDF leggibile.');
      setImporting(false); setImportProgress(''); return;
    }
    const MAX_POLL = 180;
    for (let i = 0; i < MAX_POLL; i++) {
      await new Promise(r => setTimeout(r, 4000));
      let s;
      try { s = (await listino.importStato(jobId)).data; } catch { continue; }
      setImportProgress(`Importazione in corso… (${s.create} voci finora)`);
      fetchCategorie();                       // le categorie nuove compaiono man mano
      if (inVistaLista) fetchVoci();
      if (s.stato === 'fatto') {
        setEsitoMsg(messaggioEsitoImport(s));
        fetchDaVerificare();
        setImporting(false); setImportProgress(''); return;
      }
      if (s.stato === 'errore') {
        setError(s.errore || 'Import non riuscito. Riprova.');
        setImporting(false); setImportProgress(''); return;
      }
    }
    setImporting(false); setImportProgress('');
    setEsitoMsg('L\'import sta ancora elaborando. Ricarica la pagina tra poco per vedere tutte le voci.');
    fetchCategorie();
  };

  // ── Selezione multipla (dentro la vista di categoria/ricerca) ─────────
  const tutteVisibiliSelezionate = voci.length > 0 && voci.every(v => selezionate.has(v.id));
  // Toccare una spunta a mano esce dal modo «tutte le N»: da li' in poi valgono le spunte.
  const toggleUno = (id) => {
    setModoFiltro(null);
    setSelezionate(prev => {
      const next = new Set(prev); if (next.has(id)) next.delete(id); else next.add(id); return next;
    });
  };
  const toggleTutteVisibili = () => {
    setModoFiltro(null);
    setSelezionate(prev => (
      voci.length > 0 && voci.every(v => prev.has(v.id)) ? new Set() : new Set(voci.map(v => v.id))
    ));
  };
  // FE-085 — "Seleziona tutte le N": NON scarica gli id (il server ne dava al massimo 100 e ne
  // venivano eliminate 100 su N). Chiede al server QUANTE sono le voci del filtro corrente
  // (categoria o ricerca) e la loro impronta; l'eliminazione ripresenta l'impronta e il server
  // rifiuta con 409 se nel frattempo l'insieme e' cambiato. Mai l'intero listino: senza filtro
  // il server risponde 400 (DEC-111).
  const selezionaTutteFiltrate = async () => {
    try {
      const r = await listino.eliminaFiltrateAnteprima(filtroVoci());
      setModoFiltro({ conteggio: r.data.conteggio, impronta: r.data.impronta });
      setSelezionate(new Set(voci.map(v => v.id)));
    } catch { setError('Non riesco a selezionare tutte le voci. Riprova.'); }
  };
  const nSelezionate = modoFiltro ? modoFiltro.conteggio : selezionate.size;
  const annullaSelezione = () => { setModoFiltro(null); setSelezionate(new Set()); };
  // Regola 14 — la conferma e' una finestra dell'app, non window.confirm.
  const handleEliminaBatch = () => {
    if (nSelezionate < 1) return;
    setConferma({ n: nSelezionate, cambiato: false });
  };
  const confermaEliminazione = async () => {
    setBatchBusy(true); setError(''); setEsitoMsg('');
    try {
      const res = modoFiltro
        ? await listino.eliminaFiltrate(filtroVoci(), modoFiltro.impronta)
        : await listino.eliminaBatch({ ids: [...selezionate] });
      const eliminate = res.data?.eliminate ?? nSelezionate;
      setConferma(null); setModoFiltro(null); setSelezionate(new Set());
      dopoScrittura();
      setEsitoMsg(messaggioEliminate(eliminate));
    } catch (err) {
      const nuovo = modoFiltro ? rifiutoInsiemeCambiato(err) : null;
      if (nuovo && nuovo.conteggio > 0) {
        // 409: le voci del filtro sono cambiate — la finestra resta aperta sul numero NUOVO.
        setModoFiltro(nuovo);
        setConferma({ n: nuovo.conteggio, cambiato: true });
      } else if (nuovo) {
        setConferma(null); setModoFiltro(null); setSelezionate(new Set());
        dopoScrittura();
        setEsitoMsg('Nel frattempo queste voci sono già state eliminate.');
      } else {
        setConferma(null);
        setError('Eliminazione non riuscita. Riprova.');
      }
    } finally { setBatchBusy(false); }
  };
  const testiConferma = conferma
    ? testiConfermaElimina({ n: conferma.n, ambito: ambitoEliminazione(search, categoriaAttiva), cambiato: conferma.cambiato })
    : null;

  // ── Render ────────────────────────────────────────────────────────────
  // Contenitore a larghezza piena, identico alla Home (nessun cap 900 centrato).
  const wrap = { padding: isMobile ? '20px 16px' : '28px 20px 28px 32px', width: '100%', boxSizing: 'border-box' };
  if (mostraDaVerificare) {
    return (
      <div style={wrap}>
        <ListinoDaVerificare
          onChiudi={() => setMostraDaVerificare(false)}
          onCambiato={() => { fetchDaVerificare(); fetchCategorie(); if (inVistaLista) fetchVoci(); }} />
      </div>
    );
  }

  const grigliaVuota = !catLoading && categorie.length === 0 && senzaCount === 0;

  return (
    <div style={wrap}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 4 }}>🏷️ Listino prezzi</h1>
          <p style={{ fontSize: 13, color: 'var(--ds-muted)', marginBottom: 12 }}>
            Le voci riusabili del tuo listino, raggruppate per categoria. Le userai nei preventivi.
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button onClick={() => setMostraStorico(true)} style={btnSmall}>🕘 Storico import</button>
          <label style={{ ...btnSmall, display: 'inline-flex', alignItems: 'center', gap: 6, cursor: importing ? 'default' : 'pointer', opacity: importing ? 0.6 : 1 }}>
            📄 {importing ? 'Importazione…' : 'Importa da PDF'}
            <input type="file" accept=".pdf" hidden disabled={importing}
              onChange={e => { if (e.target.files?.[0]) handleImportPdf(e.target.files[0]); e.target.value = ''; }} />
          </label>
        </div>
      </div>

      {/* R9-LISTINO-NOTA — consiglio: voci singole, non abbinate. Le voci-combo (es. "Montaggio
          sanitari e rubinetteria") impediscono di prezzare quantità diverse per componente
          quando il preventivo è dettato a voce. Field test 13/09 (Vale). */}
      <div style={{ fontSize: 13, color: 'var(--ds-text)', background: 'var(--chip)', border: '1px solid var(--ds-border)', borderLeft: '3px solid var(--brand)', borderRadius: 'var(--radius-base)', padding: '10px 14px', marginBottom: 16 }}>
        <span style={{ fontWeight: 500 }}>💡 Consiglio:</span> crea voci <span style={{ fontWeight: 500 }}>singole</span>, non abbinate — per esempio «Montaggio sanitari» e «Montaggio rubinetti» separate, non «Montaggio sanitari e rubinetteria». Così, quando detti un preventivo, ogni lavorazione viene abbinata e prezzata con la sua quantità, anche quando sono diverse (3 sanitari, 6 rubinetti).
      </div>

      {importing && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: 'var(--ds-text)', background: 'var(--chip)', border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', padding: '10px 14px', marginBottom: 16 }}>
          <span className="spin" style={{ display: 'inline-block', width: 16, height: 16, border: '2px solid var(--ds-border)', borderTopColor: 'var(--brand)', borderRadius: '50%', flexShrink: 0 }} />
          {importProgress || 'Sto leggendo il PDF, può richiedere qualche secondo…'}
        </div>
      )}
      {!importing && esitoMsg && (
        <div style={{ fontSize: 13, color: 'var(--brand)', background: 'var(--chip)', border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', padding: '8px 12px', marginBottom: 16 }}>
          {esitoMsg}
        </div>
      )}

      {/* R8-IMP-DEDUP — scorciatoia "Da verificare (K)" SEMPRE in evidenza, sopra tutto */}
      {daVerificareCount > 0 && (
        <button onClick={() => setMostraDaVerificare(true)}
          style={{ display: 'block', width: '100%', textAlign: 'left', marginBottom: 16, padding: '10px 14px', border: '1px solid var(--brand)', borderRadius: 'var(--radius-base)', background: 'var(--chip)', color: 'var(--brand)', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>
          🔎 Da verificare ({daVerificareCount}) — {daVerificareCount === 1 ? 'una voce simile' : 'voci simili'} dall'import, controllale
        </button>
      )}

      {/* Ricerca — SCAVALCA le card: mostra i risultati diretti su tutte le categorie */}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 14, flexWrap: 'wrap' }}>
        <input
          placeholder="🔍 Cerca in tutto il listino (descrizione o categoria)…"
          value={searchInput}
          onChange={e => setSearchInput(e.target.value)}
          style={{ ...inputStyle, flex: 1, minWidth: 200, maxWidth: 420 }} />
        {search && <button onClick={() => setSearchInput('')} style={btnSmall}>Pulisci</button>}
        {inVistaLista && (
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--ds-muted)' }}>
            <span>Per pagina</span>
            <select value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}
              style={{ ...inputStyle, width: 'auto', cursor: 'pointer', padding: '6px 8px' }}>
              <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
            </select>
          </div>
        )}
      </div>

      {/* Form aggiungi / modifica — sempre accessibile */}
      <div style={{ padding: 16, border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', background: 'var(--chip)', marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
          {editingId ? 'Modifica voce' : 'Aggiungi voce'}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1.5fr', gap: 10 }}>
          <div>
            <label style={labelStyle}>Descrizione</label>
            <input placeholder="es. Posa piastrelle" value={form.descrizione}
              onChange={e => setForm({ ...form, descrizione: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Prezzo €</label>
            <input type="number" step="0.01" min="0" placeholder="0.00" value={form.prezzo_unitario}
              onChange={e => setForm({ ...form, prezzo_unitario: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Unità</label>
            <select value={form.unita_misura} onChange={e => setForm({ ...form, unita_misura: e.target.value })}
              style={{ ...inputStyle, cursor: 'pointer' }}>
              <option value="">—</option>
              {UNITA.map(u => <option key={u} value={u}>{u}</option>)}
            </select>
          </div>
          <div>
            <label style={labelStyle}>Categoria</label>
            <input placeholder="es. Pavimenti" value={form.categoria}
              onChange={e => setForm({ ...form, categoria: e.target.value })} style={inputStyle} />
          </div>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, cursor: 'pointer', fontSize: 13, color: 'var(--ds-muted)' }}>
          <input type="checkbox" checked={Boolean(form.eredita_metratura)}
            onChange={e => setForm({ ...form, eredita_metratura: e.target.checked })}
            style={{ width: 16, height: 16, cursor: 'pointer' }} />
          Eredita la metratura dell'appartamento (se dettata a voce senza quantità)
        </label>
        {error && <div style={{ color: 'var(--ds-danger)', fontSize: 12, marginTop: 8 }}>{error}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
          {editingId && <button onClick={resetForm} style={btnCancel}>Annulla</button>}
          <button onClick={handleSave} disabled={saving} style={btnPrimary}>
            {saving ? 'Salvo…' : editingId ? 'Salva modifiche' : 'Aggiungi'}
          </button>
        </div>
      </div>

      {/* CORPO: ricerca → lista piatta · categoria attiva → lista filtrata · altrimenti → griglia card */}
      {inVistaLista ? (
        <>
          {categoriaAttiva && !search && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
              <button onClick={tornaAllaGriglia} style={btnSmall}>← Categorie</button>
              <span style={{ fontSize: 15, fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <span style={{ width: 10, height: 10, borderRadius: '50%', background: categoriaAttiva.senza ? 'var(--ds-muted)' : coloreHex(categoriaAttiva.colore) }} />
                {categoriaAttiva.senza ? 'Senza categoria' : categoriaAttiva.nome}
              </span>
            </div>
          )}
          {search && (
            <div style={{ fontSize: 13, color: 'var(--ds-muted)', marginBottom: 10 }}>
              Risultati per «{search}» in tutto il listino{categoriaAttiva ? ' · ' : ''}
              {categoriaAttiva && <button onClick={tornaAllaGriglia} style={linkBtn}>torna alle categorie</button>}
            </div>
          )}

          {loading ? (
            <div style={{ padding: 20, color: 'var(--ds-muted)' }}>Caricamento…</div>
          ) : voci.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: 'var(--ds-muted)' }}>
              <div style={{ fontSize: 40, marginBottom: 8 }}>🏷️</div>
              {search ? `Nessuna voce trovata per «${search}».` : 'Nessuna voce in questa categoria. Aggiungila qui sopra.'}
            </div>
          ) : (
            <>
              {/* Barra selezione */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 14px', marginBottom: 8, border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', background: 'var(--chip)' }}>
                <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: 'var(--ds-text)' }}>
                  <input type="checkbox"
                    ref={el => { if (el) el.indeterminate = selezionate.size > 0 && !tutteVisibiliSelezionate; }}
                    checked={tutteVisibiliSelezionate} onChange={toggleTutteVisibili}
                    style={{ cursor: 'pointer', width: 16, height: 16 }} />
                  Seleziona tutto
                </label>
                {nSelezionate > 0 && (
                  <>
                    <span data-testid="listino-n-selezionate" style={{ fontSize: 13, color: 'var(--ds-muted)' }}>{nSelezionate} selezionate</span>
                    <button onClick={handleEliminaBatch} disabled={batchBusy}
                      style={{ ...btnSmall, marginLeft: 'auto', color: 'var(--ds-danger)', borderColor: 'var(--ds-danger)', opacity: batchBusy ? 0.6 : 1 }}>
                      {batchBusy ? 'Elimino…' : 'Elimina selezionate'}
                    </button>
                  </>
                )}
              </div>

              {/* Il link ha senso solo finche' si vede una pagina e ce ne sono altre: sparisce
                  quando le N sono gia' selezionate, o appena si tocca una spunta. */}
              {modoFiltro && (
                <div style={escalationStyle} data-testid="listino-tutte-selezionate">
                  Selezionate tutte le {modoFiltro.conteggio} voci {ambitoEliminazione(search, categoriaAttiva)}.{' '}
                  <button onClick={annullaSelezione} style={linkBtn}>Annulla la selezione</button>
                </div>
              )}
              {!modoFiltro && tutteVisibiliSelezionate && count > voci.length && (
                <div style={escalationStyle}>
                  Selezionate le {voci.length} voci di questa pagina.{' '}
                  <button onClick={selezionaTutteFiltrate} style={linkBtn}>
                    Seleziona tutte le {count} {search ? 'trovate' : 'di questa categoria'}
                  </button>
                </div>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {voci.map(v => (
                  <div key={v.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', background: selezionate.has(v.id) ? 'var(--chip)' : 'var(--ds-bg)' }}>
                    <input type="checkbox" checked={selezionate.has(v.id)}
                      onChange={() => toggleUno(v.id)} style={{ cursor: 'pointer', width: 16, height: 16, flexShrink: 0 }} />
                    <div style={{ flex: 2 }}>
                      <div style={{ fontSize: 14, color: 'var(--ds-text)' }}>{v.descrizione}</div>
                      {/* in ricerca la categoria è utile (si vede da dove viene); nella vista di categoria è ridondante */}
                      {v.categoria_nome && search && (
                        <div style={{ fontSize: 11, color: 'var(--ds-muted)', display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                          <span style={{ width: 7, height: 7, borderRadius: '50%', background: coloreHex(v.categoria_colore) }} />
                          {v.categoria_nome}
                        </div>
                      )}
                      {v.stato_import === 'aggiornata' && (
                        <div style={{ marginTop: 3, display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                          <span style={{ fontSize: 11, color: 'var(--brand)', background: 'var(--chip)', border: '1px solid var(--ds-border)', borderRadius: 99, padding: '1px 8px' }}>
                            aggiornata {etichettaAggiornata(v)}
                          </span>
                          <button onClick={() => listino.archiviaBadge(v.id).then(dopoScrittura)}
                            style={{ background: 'none', border: 'none', color: 'var(--ds-muted)', cursor: 'pointer', fontSize: 11, padding: 0, textDecoration: 'underline' }}>✓ visto</button>
                        </div>
                      )}
                    </div>
                    <div style={{ flex: 1, fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>
                      € {Number(v.prezzo_unitario).toFixed(2)}{v.unita_misura ? ` / ${v.unita_misura}` : ''}
                    </div>
                    <button onClick={() => handleEdit(v)} style={btnSmall}>Modifica</button>
                    <button onClick={() => handleDelete(v.id)} style={{ ...btnSmall, color: 'var(--ds-danger)' }}>Elimina</button>
                  </div>
                ))}
              </div>

              {totalPages > 1 && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14, marginTop: 12, fontSize: 13, color: 'var(--ds-muted)' }}>
                  <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page <= 1}
                    style={{ ...btnSmall, opacity: page <= 1 ? 0.5 : 1, cursor: page <= 1 ? 'default' : 'pointer' }}>← Precedente</button>
                  <span>Pagina {page} di {totalPages} · {count} voci</span>
                  <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page >= totalPages}
                    style={{ ...btnSmall, opacity: page >= totalPages ? 0.5 : 1, cursor: page >= totalPages ? 'default' : 'pointer' }}>Successiva →</button>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        /* GRIGLIA CATEGORIE (home del listino) */
        catLoading ? (
          <div style={{ padding: 20, color: 'var(--ds-muted)' }}>Caricamento categorie…</div>
        ) : grigliaVuota ? (
          <div style={{ padding: 40, textAlign: 'center', color: 'var(--ds-muted)' }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>🏷️</div>
            Nessuna voce a listino. Aggiungi la prima qui sopra, oppure importa un PDF.
          </div>
        ) : (
          <>
            {categorie.length > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
                {!selCatMode ? (
                  <button onClick={() => setSelCatMode(true)} style={btnSmall}>Seleziona</button>
                ) : (
                  <>
                    <button onClick={uscitaSelCat} style={btnSmall}>Annulla</button>
                    <span style={{ fontSize: 13, color: 'var(--ds-muted)' }}>{catSelezionate.size} selezionate</span>
                    <button onClick={eliminaCategorieSelez} disabled={catSelezionate.size === 0}
                      style={{ ...btnSmall, marginLeft: 'auto', color: 'var(--ds-danger)', borderColor: 'var(--ds-danger)', opacity: catSelezionate.size === 0 ? 0.5 : 1 }}>
                      Elimina selezionate
                    </button>
                  </>
                )}
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
              {categorie.map(cat => (
                <CardCategoria key={cat.id} cat={cat}
                  selMode={selCatMode} selected={catSelezionate.has(cat.id)} onToggleSel={toggleCatSel}
                  onApri={apriCategoria} onRinomina={rinominaCategoria}
                  onColore={cambiaColore} onElimina={eliminaCategoria} />
              ))}
              {senzaCount > 0 && (
                <CardCategoria key="__senza__" cat={{ senza: true, voci_count: senzaCount }}
                  selMode={selCatMode} onApri={apriCategoria} />
              )}
            </div>
          </>
        )
      )}

      {mostraStorico && <ListinoStorico onChiudi={() => setMostraStorico(false)} />}

      {/* R8-DEDUP-MANUALE — chiedi prima di salvare un potenziale duplicato */}
      <ListinoConfermaElimina testi={testiConferma} occupato={batchBusy}
        onAnnulla={() => setConferma(null)} onConferma={confermaEliminazione} />
      {dupDialog && (
        <div onClick={() => { if (!saving) setDupDialog(null); }} style={{ position: 'fixed', inset: 0, zIndex: 1100, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: 'var(--ds-bg)', borderRadius: 'var(--radius-base)', width: '100%', maxWidth: 440, padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
            <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 8 }}>
              {dupDialog.caso === 'identica' ? 'Voce già presente' : 'Voce simile già presente'}
            </div>
            <div style={{ fontSize: 13, color: 'var(--ds-text)', marginBottom: 16, lineHeight: 1.5 }}>
              {dupDialog.caso === 'identica' ? (
                <>Esiste già <b>«{dupDialog.voce.descrizione}»</b> a € {Number(dupDialog.voce.prezzo_unitario).toFixed(2).replace('.', ',')}{dupDialog.voce.unita_misura ? ` / ${dupDialog.voce.unita_misura}` : ''}. </>
              ) : (
                <>La voce <b>«{form.descrizione}»</b> assomiglia a <b>«{dupDialog.voce.descrizione}»</b> già presente. </>
              )}
              {editingId ? 'Vuoi unirle o tenerle separate?' : 'Vuoi aggiornare quella col nuovo prezzo o creare una voce separata?'}
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              <button disabled={saving} onClick={() => salvaVoce()} style={btnCancel}>
                {editingId ? 'Tieni separate' : 'Crea separata'}
              </button>
              <button disabled={saving} onClick={() => applicaAEsistente(dupDialog.voce)} style={btnPrimary}>
                {editingId ? `Unisci con «${dupDialog.voce.descrizione}»` : `Aggiorna «${dupDialog.voce.descrizione}»`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const inputStyle = { padding: '8px 12px', borderRadius: 6, border: '1px solid var(--ds-border)', fontSize: 13, width: '100%', background: 'var(--ds-bg)', color: 'var(--ds-text)', boxSizing: 'border-box' };
const labelStyle = { fontSize: 11, color: 'var(--ds-muted)', display: 'block', marginBottom: 3, textTransform: 'uppercase' };
const btnPrimary = { padding: '9px 18px', borderRadius: 6, border: 'none', background: 'var(--brand)', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500 };
const btnCancel = { padding: '8px 16px', borderRadius: 6, border: '1px solid var(--ds-border)', background: 'var(--ds-bg)', color: 'var(--ds-muted)', cursor: 'pointer', fontSize: 12 };
const btnSmall = { padding: '5px 12px', borderRadius: 6, border: '1px solid var(--ds-border)', background: 'var(--ds-bg)', color: 'var(--ds-text)', cursor: 'pointer', fontSize: 12 };
const menuItem = { display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, color: 'var(--ds-text)', borderRadius: 6 };
const escalationStyle = { fontSize: 12, color: 'var(--ds-muted)', background: 'var(--ds-bg)', border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', padding: '8px 12px', marginBottom: 8 };
const linkBtn = { border: 'none', background: 'none', padding: 0, color: 'var(--brand)', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' };
